const React = require('react');
const { createElement: h } = React;
require('./ErrorPage.css');

function ErrorPage(props) {
  return h('div', { className: 'error-page' },
    h('div', { className: 'error-card' },
      h('h1', { className: 'error-title' }, props.title || 'Error'),
      h('p', { className: 'error-message' }, props.message || 'An unexpected error occurred.'),
      h('button', {
        className: 'error-retry-button',
        type: 'button',
        onClick: function() {
          window.location.reload();
        }
      }, 'Reload')
    )
  );
}

module.exports = ErrorPage;
